import styled from '@emotion/styled';
import * as React from 'react';

import { Spacer } from '@travelnest/merlin.spacer';

import { IconButton } from '@travelnest/merlin.button-icon';
import { InlineError, InlineTip } from '@travelnest/merlin.inline-message';
import { IImage } from '../../../api/images';
import {
	formatOrientation,
	isBadlyOriented,
	isLowRes,
	smallestGreaterThanOrEq
} from '../../../entities/images/helpers';
import { Handlebar, IHandlebarProps } from './Handlebar';

export interface IPhotoTileProps extends IHandlebarProps {
	id: string;
	index: number;
	isDisabled: boolean;
	image: IImage;
	onViewClick?: () => void;
	onDeleteClick?: () => void;
}

const StyledIconButton = styled(IconButton)`
	height: 36px;
	width: 36px;
	border-radius: 50%;
	margin-left: 5px;
`;

const StyledTileHeader = styled.div`
	font-weight: 500;
	font-size: 1rem;
	line-height: 1.25rem;
	margin-right: 10px;

	@media screen and (max-width: 600px) {
		margin: 5px 0;
	}
`;

export const PhotoTile: React.FC<IPhotoTileProps> = (props) => {
	const {
		isDisabled,
		image,
		index,
		onViewClick,
		onDeleteClick,
	} = props;

	const classes = ['photo-tile'];

	if (isDisabled) {
		classes.push('photo-tile--disabled');
	}

	const url = smallestGreaterThanOrEq(image, '350x250').url;
	const orientation = formatOrientation(image);

	return <div className={classes.join(' ')}>
		<Handlebar {...props} />
		<div className="photo-tile__body">
			<div className={`photo-tile__image-wrap photo-tile__image-wrap--${orientation.toLowerCase()}`}>
				<img
					className={`photo-tile__image photo-tile__image--${orientation.toLowerCase()}`}
					src={url}
					alt={`Photo ${index + 1}`} />
			</div>
			<div className="photo-tile__content">
				<div className="photo-tile__tags">
					<div className="photo-tile__tags__properties">
						<StyledTileHeader>Photo {index + 1}</StyledTileHeader>
						<Spacer spacing="smallest" />
						<div className="photo-tile__tags__properties--message">
							{index === 0 ? <InlineTip text="Cover photo" /> : null}
						</div>
						<div className="photo-tile__tags__properties--message">
							{isLowRes(image) ? <InlineError text="Low resolution" /> : null}
						</div>
						<div className="photo-tile__tags__properties--message">
							{isBadlyOriented(image) ? <InlineError text={orientation} /> : null}
						</div>
					</div>
				</div>
				{!isDisabled ?
					<div className="photo-tile__actions">
						<StyledIconButton
							icon="fullscreen"
							iconPosition="center"
							label="View photo"
							onClick={(e) => { e.preventDefault(); if (onViewClick) onViewClick(); }}
						/>
						<StyledIconButton
							icon="trash"
							iconPosition="center"
							label="Delete photo"
							onClick={(e) => { e.preventDefault(); if (onDeleteClick) onDeleteClick(); }}
						/>
					</div> : null
				}
			</div>
		</div>
	</ div>;
};

export default PhotoTile;
